var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "AppNavigationItem",
    {
      directives: [
        {
          name: "click-outside",
          rawName: "v-click-outside",
          value: _vm.closeShareMenu,
          expression: "closeShareMenu"
        }
      ],
      class: {
        deleted: !!_vm.deleteTimeout,
        disabled: !_vm.calendar.enabled,
        "open-sharing": _vm.shareMenuOpen
      },
      attrs: {
        loading: _vm.calendar.loading,
        title:
          _vm.calendar.displayName || _vm.$t("calendar", "Untitled calendar")
      },
      on: {
        click: function($event) {
          $event.preventDefault()
          $event.stopPropagation()
          return _vm.toggleEnabled($event)
        }
      }
    },
    [
      _vm.calendar.enabled
        ? _c("AppNavigationIconBullet", {
            attrs: { slot: "icon", color: _vm.calendar.color },
            on: {
              click: function($event) {
                $event.preventDefault()
                $event.stopPropagation()
                return _vm.toggleEnabled($event)
              }
            },
            slot: "icon"
          })
        : _vm._e(),
      _vm._v(" "),
      !_vm.calendar.enabled
        ? _c("AppNavigationDisabledCalendarIconBullet", {
            attrs: { slot: "icon" },
            on: {
              click: function($event) {
                $event.preventDefault()
                $event.stopPropagation()
                return _vm.toggleEnabled($event)
              }
            },
            slot: "icon"
          })
        : _vm._e(),
      _vm._v(" "),
      !_vm.deleteTimeout
        ? _c(
            "template",
            { slot: "counter" },
            [
              _vm.showSharingIcon
                ? _c(
                    "Actions",
                    [
                      _c("ActionButton", {
                        attrs: { icon: _vm.sharingIconClass },
                        on: { click: _vm.toggleShareMenu }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.isSharedWithMe && _vm.loadedOwnerPrincipal
                ? _c("Avatar", {
                    attrs: {
                      user: _vm.ownerUserId,
                      "display-name": _vm.ownerDisplayname
                    }
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.isSharedWithMe && !_vm.loadedOwnerPrincipal
                ? _c("div", { staticClass: "icon icon-loading" })
                : _vm._e()
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      !_vm.deleteTimeout
        ? _c(
            "template",
            { slot: "actions" },
            [
              _vm.showRenameLabel
                ? _c(
                    "ActionButton",
                    {
                      attrs: { icon: "icon-rename" },
                      on: {
                        click: function($event) {
                          $event.preventDefault()
                          $event.stopPropagation()
                          return _vm.openRenameInput($event)
                        }
                      }
                    },
                    [
                      _vm._v(
                        "\n\t\t\t" +
                          _vm._s(_vm.$t("calendar", "Edit name")) +
                          "\n\t\t"
                      )
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.showRenameInput
                ? _c("ActionInput", {
                    attrs: {
                      icon: "icon-rename",
                      value: _vm.calendar.displayName
                    },
                    on: {
                      submit: function($event) {
                        $event.preventDefault()
                        $event.stopPropagation()
                        return _vm.saveRenameInput($event)
                      }
                    }
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.showRenameSaving
                ? _c("ActionText", { attrs: { icon: "icon-loading-small" } }, [
                    _vm._v(
                      "\n\t\t\t" +
                        _vm._s(_vm.$t("calendar", "Saving name …")) +
                        "\n\t\t"
                    )
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.showColorLabel
                ? _c(
                    "ActionButton",
                    {
                      attrs: { icon: "icon-rename" },
                      on: {
                        click: function($event) {
                          $event.preventDefault()
                          $event.stopPropagation()
                          return _vm.openColorInput($event)
                        }
                      }
                    },
                    [
                      _vm._v(
                        "\n\t\t\t" +
                          _vm._s(_vm.$t("calendar", "Edit color")) +
                          "\n\t\t"
                      )
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.showColorInput
                ? _c("ActionInput", {
                    attrs: {
                      icon: "icon-rename",
                      value: _vm.calendar.color,
                      type: "color"
                    },
                    on: {
                      submit: function($event) {
                        $event.preventDefault()
                        $event.stopPropagation()
                        return _vm.saveColorInput($event)
                      }
                    }
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.showColorSaving
                ? _c("ActionText", { attrs: { icon: "icon-loading-small" } }, [
                    _vm._v(
                      "\n\t\t\t" +
                        _vm._s(_vm.$t("calendar", "Saving color …")) +
                        "\n\t\t"
                    )
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c(
                "ActionButton",
                {
                  attrs: { icon: "icon-clippy" },
                  on: {
                    click: function($event) {
                      $event.stopPropagation()
                      $event.preventDefault()
                      return _vm.copyLink($event)
                    }
                  }
                },
                [
                  _vm._v(
                    "\n\t\t\t" +
                      _vm._s(_vm.$t("calendar", "Copy private link")) +
                      "\n\t\t"
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "ActionLink",
                {
                  attrs: {
                    icon: "icon-download",
                    target: "_blank",
                    href: _vm.downloadUrl
                  }
                },
                [
                  _vm._v(
                    "\n\t\t\t" +
                      _vm._s(_vm.$t("calendar", "Download")) +
                      "\n\t\t"
                  )
                ]
              ),
              _vm._v(" "),
              _vm.calendar.isSharedWithMe
                ? _c(
                    "ActionButton",
                    {
                      attrs: { icon: "icon-delete" },
                      on: {
                        click: function($event) {
                          $event.preventDefault()
                          $event.stopPropagation()
                          return _vm.deleteCalendar($event)
                        }
                      }
                    },
                    [
                      _vm._v(
                        "\n\t\t\t" +
                          _vm._s(_vm.$t("calendar", "Unshare from me")) +
                          "\n\t\t"
                      )
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              !_vm.calendar.isSharedWithMe
                ? _c(
                    "ActionButton",
                    {
                      attrs: { icon: "icon-delete" },
                      on: {
                        click: function($event) {
                          $event.preventDefault()
                          $event.stopPropagation()
                          return _vm.deleteCalendar($event)
                        }
                      }
                    },
                    [
                      _vm._v(
                        "\n\t\t\t" +
                          _vm._s(_vm.$t("calendar", "Delete")) +
                          "\n\t\t"
                      )
                    ]
                  )
                : _vm._e()
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      !!_vm.deleteTimeout
        ? _c(
            "template",
            { slot: "actions" },
            [
              _vm.calendar.isSharedWithMe
                ? _c(
                    "ActionButton",
                    {
                      attrs: { icon: "icon-history" },
                      on: {
                        click: function($event) {
                          $event.preventDefault()
                          $event.stopPropagation()
                          return _vm.cancelDeleteCalendar($event)
                        }
                      }
                    },
                    [
                      _vm._v(
                        "\n\t\t\t" +
                          _vm._s(
                            _vm.$n(
                              "calendar",
                              "Unsharing the calendar in {countdown} second",
                              "Unsharing the calendar in {countdown} seconds",
                              _vm.countdown,
                              { countdown: _vm.countdown }
                            )
                          ) +
                          "\n\t\t"
                      )
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              !_vm.calendar.isSharedWithMe
                ? _c(
                    "ActionButton",
                    {
                      attrs: { icon: "icon-history" },
                      on: {
                        click: function($event) {
                          $event.preventDefault()
                          $event.stopPropagation()
                          return _vm.cancelDeleteCalendar($event)
                        }
                      }
                    },
                    [
                      _vm._v(
                        "\n\t\t\t" +
                          _vm._s(
                            _vm.$n(
                              "calendar",
                              "Deleting the calendar in {countdown} second",
                              "Deleting the calendar in {countdown} seconds",
                              _vm.countdown,
                              { countdown: _vm.countdown }
                            )
                          ) +
                          "\n\t\t"
                      )
                    ]
                  )
                : _vm._e()
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      !_vm.deleteTimeout
        ? [
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.shareMenuOpen,
                    expression: "shareMenuOpen"
                  }
                ],
                staticClass: "sharing-section"
              },
              [
                _vm.calendar.canBeShared
                  ? _c("CalendarListItemSharingSearch", {
                      attrs: { calendar: _vm.calendar }
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm.calendar.canBePublished
                  ? _c("CalendarListItemSharingPublishItem", {
                      attrs: { calendar: _vm.calendar }
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm._l(_vm.calendar.shares, function(sharee) {
                  return _c("CalendarListItemSharingShareItem", {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.shareMenuOpen,
                        expression: "shareMenuOpen"
                      }
                    ],
                    key: sharee.uri,
                    attrs: { sharee: sharee, calendar: _vm.calendar }
                  })
                })
              ],
              2
            )
          ]
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }